import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { HereMapService } from '../here-map.service';
import { filter, take } from 'rxjs/operators';

@Component({
  selector: 'i2g-here-marker',
  template: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HereMarkerComponent implements OnInit, AfterViewInit {
  /**
   * Latitude
   */
  @Input() lat: number;

  /**
   * Longitude
   */
  @Input() lng: number;

  constructor(private _hereMapService: HereMapService) {}

  ngOnInit() {}

  ngAfterViewInit() {
    // TODO[profile]: support latitude, longitude changes
    this._hereMapService.mapReady$
      .pipe(
        filter((x) => !!x),
        take(1)
      )
      .subscribe(() => {
        this._hereMapService.addMarker(this.lat, this.lng);
      });
  }
}
